// extracted by mini-css-extract-plugin
export default {"menuCloseButton":"NavMenu_menuCloseButton__FR8Zx","menuUserInfo":"NavMenu_menuUserInfo__NhI1P","menuInfoWrapper":"NavMenu_menuInfoWrapper__LRGul"};